import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getDatabase, ref, get, set, remove, onValue, update,push } from "firebase/database";
import app from "../../../firebaseConfig";
import { Modal, Box, Typography, IconButton, Card, CardContent, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt"; // Icono de Factura
import CloseIcon from "@mui/icons-material/Close"; // Icono de Cerrar
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart"; // Icono de Carrito
import { getFunctions, httpsCallable } from "firebase/functions";

import Alertadenegado from "../alertadenegado"; 

function ResumenPedidos() {
  
  const navigate = useNavigate(); // Hook para navegar entre páginas
  const location = useLocation();
  const [productos, setProductos] = useState([]);
  const { mesa, empleado, nota } = location.state || {}; // Obtener valores del estado
  const [open, setOpen] = useState(false); // Controla el modal

  const [nombreTitular, setNombreTitular] = useState(() => {
    return localStorage.getItem("titularpedido") || "";
  });
  const [correoCliente, setCorreoCliente] = useState(() => {
    return localStorage.getItem("correocliente") || "";
  });
  const [correoValido, setCorreoValido] = useState(true);
  const [codigoMesa, setCodigoMesa] = useState("");
  const [codigoIngresado, setCodigoIngresado] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  const [notaEditable, setNotaEditable] = useState(() => {
    return localStorage.getItem("notaEditablePedido") || "";
  });
  

   const [denegado, setDenegado] = useState(false);

   const [tarifaEnvio, setTarifaEnvio] = useState(0);
   const [umbralGratis, setUmbralGratis] = useState(0);
   
   
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [envioConfig, setEnvioConfig] = useState({ Gratis: 0, Tarifa: 0 });



  const departamentosColombia = [
    "Amazonas", "Antioquia", "Arauca", "Atlántico", "Bogotá D.C.",
    "Bolívar", "Boyacá", "Caldas", "Caquetá", "Casanare", "Cauca", "Cesar",
    "Chocó", "Córdoba", "Cundinamarca", "Guainía", "Guaviare", "Huila",
    "La Guajira", "Magdalena", "Meta", "Nariño", "Norte de Santander",
    "Putumayo", "Quindío", "Risaralda", "San Andrés y Providencia",
    "Santander", "Sucre", "Tolima", "Valle del Cauca", "Vaupés", "Vichada"
  ];

  const ciudadesColombia = [
    "Bogotá", "Medellín", "Cali", "Barranquilla", "Cartagena",
    "Cúcuta", "Bucaramanga", "Villavicencio", "Santa Marta",
    "Pereira", "Manizales", "Armenia", "Ibagué",
    // ... puedes agregar todas las que necesites
  ];
  

  const [formulario, setFormulario] = useState({
    nombre: "",
    apellidos: "",
    cedulaEmpresa: "",
    direccion: "",
    adicional: "",
    ciudad: "",
    provincia: "",
    codigoPostal: "",
    telefono: ""
  });

  const handleChange = (e) => {
    setFormulario({ ...formulario, [e.target.name]: e.target.value });
  };

  ///////////////////
  //Estado seleciconado para checkbox Mercado Pago
  const [seleccionado, setSeleccionado] = useState(true);
  const handleCheckbox = () => {
    setSeleccionado(!seleccionado);
  };
  // Definir el color dinámico según si está seleccionado
  const colorActivo = seleccionado ? "#87e310" : "#ccc";
  //////////////////////////////



//Traemos los valores desde Firebase de envio
useEffect(() => {
  const db = getDatabase(app);
  const refEnvio = ref(db, "nature/Awoo/Control/Envio");

  onValue(refEnvio, (snap) => {
    if (snap.exists()) {
      setEnvioConfig(snap.val());
      console.log("📦 Config de envío cargada:", snap.val());
    }
  });
}, []);



// Cargar carrito y valores de envío
useEffect(() => {
  const carritoGuardado = localStorage.getItem("carrito");
  if (carritoGuardado) {
    setProductos(JSON.parse(carritoGuardado));
  }

  const db = getDatabase(app);
  const envioRef = ref(db, "nature/Awoo/Control/Envio/Tarifa");
  const gratisRef = ref(db, "nature/Awoo/Control/Envio/Gratis");

  get(envioRef).then((snapshot) => {
    if (snapshot.exists()) {
      setTarifaEnvio(parseInt(snapshot.val()) || 0);
    }
  });

  get(gratisRef).then((snapshot) => {
    if (snapshot.exists()) {
      setUmbralGratis(parseInt(snapshot.val()) || 0);
    }
  });
}, []);

  useEffect(() => {
    const db = getDatabase();
    const codigoRef = ref(db, "nature/Awoo/Control/CodigoMesas");
    get(codigoRef).then((snapshot) => {
      if (snapshot.exists() && snapshot.val().trim() !== "") {
        setCodigoMesa(snapshot.val().trim());
      }
    });
  }, []);

  //////// Esto detecta ancho de la pantalla automaticamente para 1 o 2 columnas
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /////////////
      ////////////////// 🚫 Si el acceso está denegado, solo muestra el AlertDialog
      if (denegado) {
        return (
          <Alertadenegado
            open={true}
            onClose={() => {
              setDenegado(false);
              navigate(-1); // Regresa a la página anterior o redirige donde necesites
            }}
          />
        );
      }
      ///////////////////////////

      
  const enviarPedido = async () => {
    const db = getDatabase();
    const pedidosRef = ref(db, "nature/Awoo/Pedidos/Solicitados");
  
    // Obtener la fecha y hora actuales
    const ahora = new Date();
    const fecha = ahora.toLocaleDateString("es-CO");
    const hora = ahora.toLocaleTimeString("es-CO");
    const timestamp = ahora.getTime();
  
    // Construir el pedido
    const nuevoPedido = {
      titular: nombreTitular.trim(),
      correo: correoCliente.trim() || "No proporcionado",
      mesa: mesa || "Sin número",
      productos: productos
        .map((p) => ({
          titulo: p.Titulo.trim(),
          cantidad: Number(p.cantidad) || 1,
          precioUnitario: Number(p.Precio) || 0,
          costoUnitario: Number(p.Costo) || 0,
          total: (Number(p.Precio) || 0) * (Number(p.cantidad) || 1),
        }))
        .sort((a, b) => a.titulo.localeCompare(b.titulo)), // Ordenar productos por título
      totalPedido: calcularTotal(),
      fecha,
      hora,
      timestamp,
      empleado: empleado || "No Asignado",
      nota: notaEditable.trim() || ""

    };
  
    try {

        // 👉 Guardar los valores importantes antes de limpiar
  const adminKey = localStorage.getItem("adminKey");
  const adminAuthTime = localStorage.getItem("adminAuthTime");

      // Obtener los pedidos actuales en Firebase
      const snapshot = await get(pedidosRef);
      if (snapshot.exists()) {
        const pedidos = snapshot.val();
  
        for (const key in pedidos) {
          const pedido = pedidos[key];
  
          // Asegurar que los productos se comparen de manera ordenada
          const productosOrdenados = (pedido.productos || [])
            .map((p) => ({
              titulo: p.titulo.trim(),
              cantidad: Number(p.cantidad) || 1,
              precioUnitario: Number(p.precioUnitario) || 0,
              costoUnitario: Number(p.costoUnitario) || 0,
              total: Number(p.total) || 0,
            }))
            .sort((a, b) => a.titulo.localeCompare(b.titulo));
  
          if (
            pedido.titular.trim() === nuevoPedido.titular &&
            Number(pedido.totalPedido) === Number(nuevoPedido.totalPedido) &&
            JSON.stringify(productosOrdenados) === JSON.stringify(nuevoPedido.productos)
          ) {
            alert("⚠️ Tu pedido ya está en la lista del admin.");
            return;
          }
        }
      }
  
      // Si no hay duplicado, guardar el nuevo pedido
      await push(pedidosRef, nuevoPedido);

      // ✅ Limpiar almacenamiento local
      localStorage.clear();

        // 🔁 Restaurar los valores de admin
  if (adminKey) localStorage.setItem("adminKey", adminKey);
  if (adminAuthTime) localStorage.setItem("adminAuthTime", adminAuthTime);
  
      // ✅ Cerrar modales y alertDialog
      setOpen(false);
      setOpenDialog(false);
  
// ✅ Redirigir a otra página según el origen
const origen = location.state?.origen;
const rutaDestino = origen === "interfaz2"
  ? "/awoopedidointerfaz"
  : `/awooiniciousuarios?mesa=${encodeURIComponent(mesa || "")}`;

alert("✅ Pedido enviado exitosamente 🎉");
navigate(rutaDestino);

    } catch (error) {
      console.error("❌ Error al enviar el pedido:", error);
      alert("Hubo un error al enviar el pedido. Inténtalo de nuevo.");
    }
  };
  const validarCorreo = (correo) => {
    if (!correo) return true; // Si está vacío, es válido (porque es opcional)
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo);
  };
  const handleConfirmar = () => {
    if (!nombreTitular.trim()) {
      alert("Debes ingresar un nombre para el titular del pedido.");
      return;
    }
    if (!correoValido) {
      alert("Por favor, ingresa un correo electrónico válido.");
      return;
    }
    if (codigoMesa) {
      setOpenDialog(true);
    } else {
      enviarPedido();
    }
  };
 // Función para aumentar la cantidad de un producto
 const aumentarCantidad = (index) => {
  const nuevosProductos = [...productos];
  nuevosProductos[index].cantidad = (nuevosProductos[index].cantidad || 1) + 1;
  setProductos(nuevosProductos);
  localStorage.setItem("carrito", JSON.stringify(nuevosProductos)); // Guardar cambios
};
// Función para disminuir la cantidad de un producto
const disminuirCantidad = (index) => {
  const nuevosProductos = [...productos];
  if (nuevosProductos[index].cantidad > 1) {
    nuevosProductos[index].cantidad -= 1;
    setProductos(nuevosProductos);
    localStorage.setItem("carrito", JSON.stringify(nuevosProductos)); // Guardar cambios
  }
};
// Función para eliminar un producto con confirmación
const eliminarProducto = (index) => {
    const confirmar = window.confirm("¿Estás seguro de que deseas eliminar este producto?");
    if (confirmar) {
      const nuevosProductos = productos.filter((_, i) => i !== index);
      setProductos(nuevosProductos);
      localStorage.setItem("carrito", JSON.stringify(nuevosProductos)); // Guardar cambios
    }
  };
const verificarCodigo = () => {
    if (codigoIngresado === codigoMesa) {
      setOpenDialog(false);
      enviarPedido();
    } else {
      alert("Código incorrecto. Inténtalo nuevamente.");
    }
  };
// Mostrar resumen del pedido en un alert
const mostrarResumenPedido = () => {
    if (productos.length === 0) {
      alert("El carrito está vacío.");
      return;
    }

    let resumen = `📌 Mesa: ${mesa || "Sin número"}\n\n`;

    productos.forEach((producto) => {
      const subtotal = (producto.Precio || 0) * (producto.cantidad || 1);
      resumen += `🛒 ${producto.Titulo}\n`;
      resumen += `   Cantidad: ${producto.cantidad || 1}\n`;
      resumen += `   Total: $${subtotal.toLocaleString("es-CO")}\n\n`;
    });

    resumen += `💰 Total del Pedido: $${calcularTotal()}`;
    
    alert(resumen);
  };
// Calcular el total del pedido
const calcularTotal = () => {
  const total = productos.reduce(
    (total, producto) => total + (producto.Precio || 0) * (producto.cantidad || 1),
    0
  );

  return total; // Formatea el total con puntos como separadores de 
};
const formularioValido = () => {
  const camposObligatorios = [
    formulario.nombre,
    formulario.apellidos,
    formulario.cedulaEmpresa,
    formulario.direccion,
    formulario.ciudad,
    formulario.provincia,
    formulario.correo,
    formulario.telefono
  ];

  return camposObligatorios.every((campo) => campo && campo.trim() !== "");
};



//-----Crea función para iniciar pago
const pagarConMercadoPago = async () => {
  console.log("────────────────────────────────────────────");
  console.log("🟦 pagarConMercadoPago INVOCADO");

  try {
    const functions = getFunctions();
    const createPreference = httpsCallable(functions, "createPreference");

    console.log("🛒 Productos:", productos);
    console.log("💰 Total calculado antes de convertir:", calcularTotalConEnvio());

    let total = calcularTotalConEnvio();

    console.log("📌 Total numérico inicial:", total);

    total = String(total)
      .replace(/\./g, "")
      .replace(/,/g, ".")
      .trim();

    console.log("📌 Total procesado:", total);

    const totalNumerico = Number(total);

    console.log("💰 Total FINAL a enviar:", totalNumerico);

    if (isNaN(totalNumerico) || totalNumerico <= 0) {
      console.error("❌ TOTAL INVALIDO:", total, totalNumerico);
      alert("Error: el total a pagar no es válido.");
      return;
    }

    console.log("📤 Enviando createPreference a Firebase...");
    console.log("🟦 Enviando a createPreference:", {
      title: "...",
      amount: totalNumerico,
      nombre: formulario.nombre,
      email: correoCliente
    });
    
    // nos aseguramos de tener `productos`
console.log("🛒 Productos:", productos);

    const result = await createPreference({
      title: "Compra en 3D Fyrion",
      amount: totalNumerico,
      nombre: formulario.nombre,
      email: correoCliente,
      productos: productos,

      apellido: formulario.apellidos,
      cedula: formulario.cedulaEmpresa,
      direccion: formulario.direccion,
      detalles: formulario.detalles,
      ciudad: formulario.ciudad,
      departamento: formulario.provincia,
      correo: formulario.correo,
      telefono:formulario.telefono,

        // 🔵 🔵 NUEVO: valores de envío
  envioGratis: envioConfig.Gratis,
  envioTarifa: envioConfig.Tarifa
      
    });

    console.log("🟢 Respuesta de createPreference:", result);

    const preferenceId = result.data.id;

    console.log("🆔 Preference ID recibido:", preferenceId);

    const mp = new window.MercadoPago("APP_USR-71ae28aa-47f2-4305-bef5-2527655a2bf9", {
      locale: "es-CO"
    });

    console.log("🟣 Inicializando checkout de Mercado Pago...");

    mp.checkout({
      preference: { id: preferenceId },
      autoOpen: true
    });

    console.log("🟢 Checkout iniciado correctamente");

  } catch (error) {
    console.error("❌ ERROR GRAVE EN pagarConMercadoPago:", error);
    alert("Hubo un error procesando el pago.");
  }
};



/// Funciones de Calculo
const calcularCantidadProductos = () => {
  return productos.reduce((acc, item) => acc + parseInt(item.cantidad), 0);
};
const calcularSubtotalProductos = () => {
  return productos.reduce(
    (acc, item) => acc + parseInt(item.cantidad) * parseInt(item.Precio),
    0
  );
};
   ///// Calculos adicionales para costos
   const subtotal = calcularSubtotalProductos();
   const envioGratisDisponible = subtotal >= umbralGratis;
   const envioActual = envioGratisDisponible ? 0 : tarifaEnvio;
   
   const calcularTotalConEnvio = () => subtotal + envioActual;
   const porcentajeEnvio = Math.min((subtotal / umbralGratis) * 100, 100);
   const restante = Math.max(umbralGratis - subtotal, 0);
   
     //////////////////////////////////////////////////



     const inputStyle = {
        flex: 1,
        minWidth: "200px",
        padding: "10px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        fontSize: "16px",
      };

      const logoStyle = {
        height: "24px",
        objectFit: "contain",
        backgroundColor: "#fff",
        padding: "2px 4px",
        borderRadius: "4px",
      };



  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "92vh",
        background: "#fff",
        padding: "15px",
      }}
    >
{/* --- Contenedor del título "Carrito de COmpras" --- */}
<div style={{ position: "relative", marginBottom: "15px" }}>


<div className="cho-container"></div>


  {/* --- CardView del título Resumen --- */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "10px",
      borderRadius: "10px",
      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
    }}
  >
    <strong style={{ fontSize: "24px", color: "#000" }}>3D Fyrion | Colombia</strong>
  </div>

</div>


<div
  style={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    gap: "20px",
    background: "#fff",
    padding: "20px",
  }}
>
  {/* 🟣 Columna izquierda */}
  <div style={{ flex: 1, minWidth: "300px" }}>
    {/* Contenedor de Formulario*/}
    <div
      style={{
        maxWidth: "800px",
        margin: "0",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
      }}
    >
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
      🟢 Entrega y Facturación
      </h2>

      {/* Fila: Nombre + Apellidos */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "15px" }}>
        <input
          type="text"
          name="nombre"
          placeholder="Nombre"
          value={formulario.nombre}
          onChange={handleChange}
          style={inputStyle}
        />
        <input
          type="text"
          name="apellidos"
          placeholder="Apellidos"
          value={formulario.apellidos}
          onChange={handleChange}
          style={inputStyle}
        />
      </div>

      {/* Cédula / Empresa */}
      <div style={{ marginBottom: "15px" }}>
        <input
          type="text"
          name="cedulaEmpresa"
          placeholder="Cédula o Empresa"
          value={formulario.cedulaEmpresa}
          onChange={handleChange}
          style={{ ...inputStyle, width: "100%" }}
        />
      </div>

      {/* Dirección */}
      <div style={{ marginBottom: "15px" }}>
        <input
          type="text"
          name="direccion"
          placeholder="Dirección / Barrio"
          value={formulario.direccion}
          onChange={handleChange}
          style={{ ...inputStyle, width: "100%" }}
        />
      </div>

      {/* Casa / Apartamento / Otros (opcional) */}
      <div style={{ marginBottom: "15px" }}>
        <input
          type="text"
          name="adicional"
          placeholder="Casa, Apartamento, Detalles (opcional)"
          value={formulario.adicional}
          onChange={handleChange}
          style={{ ...inputStyle, width: "100%" }}
        />
      </div>

      {/* Fila: Ciudad + Departamento + Código Postal */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "15px" }}>
     
        <select
          name="provincia"
          value={formulario.provincia}
          onChange={handleChange}
          style={{ ...inputStyle, flex: 1 }}
        >
          <option value="">Provincia / Departamento</option>
          {departamentosColombia.map((dep) => (
            <option key={dep} value={dep}>
              {dep}
            </option>
          ))}
        </select>

        <input
          type="text"
          name="ciudad"
          placeholder="Ciudad"
          value={formulario.ciudad}
          onChange={handleChange}
          style={inputStyle}
        />

        <input
    type="email"
    name="correo"
    placeholder="Correo"
    value={formulario.correo}
    onChange={(e) => {
      handleChange(e);
      const valido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value);
      setCorreoValido(valido);
    }}
    style={{
      ...inputStyle,
      flex: 1,
      border: correoValido ? "1px solid #ccc" : "2px solid red",
      background: correoValido ? "white" : "#ffe5e5"
    }}
  />
      </div>

      {/* Teléfono */}
<div style={{ marginBottom: "15px" }}>
  <input
    type="text"
    name="telefono"
    placeholder="Teléfono"
    value={formulario.telefono}
    onChange={(e) => {
      // Solo permitir números
      const soloNumeros = e.target.value.replace(/\D/g, "");
      handleChange({
        target: { name: "telefono", value: soloNumeros }
      });
    }}
    style={{ ...inputStyle, width: "100%" }}
  />
</div>

    </div>

{/* Contenedor Mercado Pago Opción */}
<div
      style={{
        marginTop: "-26px",
        backgroundColor: "#f8f8f8",
        padding: "20px",
        borderRadius: "12px",
        maxWidth: "600px",
        margin: "0 auto",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      {/* Título */}
      <h2 style={{ color: "#000", marginBottom: "5px" }}>🟢 Pagos</h2>
      <p style={{ color: "#666", fontSize: "14px", marginBottom: "20px" }}>
        Todas las transacciones son seguras y están encriptadas.
      </p>

      {/* Opción de Mercado Pago */}
      <label
        style={{
          display: "flex",
          alignItems: "center",
          padding: "12px",
          backgroundColor: "#fff",
          border: `4px solid ${colorActivo}`,
          borderRadius: "10px",
          cursor: "pointer",
          marginBottom: "20px",
        }}
      >
        {/* Checkbox + Círculo decorativo */}
        <div style={{ display: "flex", alignItems: "center", marginRight: "12px" }}>
          <input
            type="checkbox"
            //checked={seleccionado}
            checked={true}     // siempre marcado
            disabled           // evita que se pueda modificar
            onChange={handleCheckbox}
            style={{ transform: "scale(1.3)" }}
          />
          <div
            style={{
              width: "18px",
              height: "18px",
              borderRadius: "50%",
              backgroundColor: colorActivo,
              marginLeft: "8px",
            }}
          ></div>
        </div>

        {/* Texto + logos */}
        <div style={{ flex: 1 }}>
          <strong style={{ fontSize: "18px", color: "#000" }}>Mercado Pago</strong>

          {/* Logos centrados */}
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "12px",
              flexWrap: "wrap",
            }}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg"
              alt="Visa"
              style={logoStyle}
            />
            <img
              src="https://1000marcas.net/wp-content/uploads/2019/12/logo-Mastercard.png"
              alt="MasterCard"
              style={logoStyle}
            />
            <img
              src="https://cdn.worldvectorlogo.com/logos/efecty.svg"
              alt="Efecty"
              style={logoStyle}
            />
            <strong style={{ fontSize: "28px", fontWeight: "bold", color: colorActivo }}>+</strong>
          </div>
        </div>
      </label>

      {/* Logo de sitio + mensaje */}
      <div style={{ textAlign: "center" }}>
        <img
          src="https://cdn-icons-png.flaticon.com/512/94/94774.png"
          alt=""
          style={{ height: "90px", marginBottom: "10px" }}
        />
        <p style={{ fontSize: "14px", color: "#666" }}>
          Después de hacer clic en <strong>"Pagar ahora"</strong>, serás redirigido a Mercado Pago para completar tu compra de forma segura.
        </p>
      </div>
</div>




  </div>

  {/* 🟢 Columna derecha */}
  <div style={{ flex: 1, minWidth: "300px" }}>


    {/* Resumen de Pedidos */}
  <div
      style={{
        backgroundColor: "#ececec",
        borderRadius: "15px",
        padding: "15px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
        overflowY: "auto",
        height:"240px"
      }}
    >
      {/* ...contenido de pedidos... */}
      {productos.length === 0 ? (
  <p style={{ color: "#aaa", textAlign: "center" }}>
    (No hay productos en el carrito)
  </p>
) : (
  productos.map((producto, index) => (
    <div
      key={index}
      style={{
        position: "relative", // Necesario para posicionar el botón de eliminar
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#fff",
        borderRadius: "15px",
        padding: "10px",
        border: "3px solid #02f2fa",
        boxShadow: "0 0 10px rgba(2, 242, 250, 0.7)",
        marginBottom: "10px",
        cursor: "pointer",
      }}
    >



{/* Contenedor de imagen y descuento */}
<div style={{ position: "relative", width: "80px", height: "80px", marginBottom: "20px" }}>
  {/* Imagen del producto */}
  <img
    src={producto.Img || "images/default.jpg"}
    alt={""}
    style={{
      width: "80px",
      height: "80px",
      objectFit: "cover",
      borderRadius: "50%",
    }}
  />

        {/* Cantidad Vista */}
        <button
        style={{
          position: "absolute",
          top: "-6px",
          left: "50px",
          backgroundColor: "red",
          color: "white",
          border: "none",
          borderRadius: "50%",
          width: "25px",
          height: "25px",
          fontSize: "14px",
          cursor: "pointer",
          boxShadow: "0px 2px 5px rgba(0,0,0,0.3)",
        }}
      >
        {producto.cantidad || ""}
      </button>

  {/* Descuento sobresaliendo */}
  {producto.PrecioAnterior > producto.Precio && (
    <div
      style={{
        position: "absolute",
        bottom: "-12px",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#b016b5",
        color: "#fff",
        padding: "4px 8px",
        borderRadius: "6px",
        fontSize: "12px",
        fontWeight: "bold",
        whiteSpace: "nowrap",
        boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
      }}
    >
      -{Math.round(100 - (producto.Precio * 100) / producto.PrecioAnterior)}% OFF
    </div>
  )}
</div>

{/* Contenedor de título y precio */}
<div style={{ flex: 1, marginLeft: "10px" }}>
        <div style={{ color: "black", fontWeight: "bold" }}>
          {producto.Titulo || ""}
        </div>
        <div style={{ color: "#5b5b5b", fontWeight: "bold", marginTop:"3px" }}>
          {producto.Tipovariante}:{" " + producto.variante?.Nombre} 
        </div>

        <div style={{ marginTop: "5px" }}>
  {/* Precio anterior tachado */}
  {producto.PrecioAnterior && (
    <div
      style={{
        backgroundColor: "#fff",
        color: "#999",
        padding: "5px",
        borderRadius: "10px",
        fontWeight: "bold",
        fontSize: "13px",
        display: "inline-block",
        textDecoration: "line-through",
      }}
    >
      ${producto.PrecioAnterior.toLocaleString("es-CO")}
    </div>
  )}

  {/* Precio actual */}
  <div
    style={{
      marginTop: "5px",
      backgroundColor: "#e27f0e",
      color: "white",
      padding: "5px",
      borderRadius: "10px",
      fontWeight: "bold",
      fontSize: "14px",
      display: "inline-block",
    }}
  >
    ${producto.Precio?.toLocaleString("es-CO") || "0"}
  </div>

       </div>


</div>

</div>
  ))
)}
  </div>

    {/* 🚚 Progreso hacia Envío Gratis */}
    <div
      style={{
        backgroundColor: "#ececec",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
        borderRadius: "12px",
        padding: "12px 15px",
        marginTop: "20px",
        marginBottom: "10px",
      }}
    >
      {/* ...progreso... */}
        {/* Fila: Envío + Tarifa */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "8px",
    }}
  >
    <span style={{ fontSize: "14px", color: "#000" }}>Envío</span>
    <span
      style={{
        fontSize: "14px",
        fontWeight: "bold",
        color: envioGratisDisponible ? "green" : "#000",
        textDecoration: envioGratisDisponible ? "line-through" : "none",
      }}
    >
      ${tarifaEnvio?.toLocaleString("es-CO") }
    </span>
  </div>

  {/* Barra de progreso */}
  <div
    style={{
      height: "10px",
      width: "100%",
      backgroundColor: "#444",
      borderRadius: "5px",
      overflow: "hidden",
      marginBottom: "6px",
    }}
  >
    <div
      style={{
        height: "100%",
        width: `${porcentajeEnvio}%`,
        backgroundColor: envioGratisDisponible ? "#4caf50" : "#08f9f5",
        transition: "width 0.3s ease-in-out",
      }}
    ></div>
  </div>

  {/* Texto bajo la barra */}
  <span
    style={{
      fontSize: "13px",
      color: envioGratisDisponible ? "#4caf50" : "#000",
      fontWeight: "bold",
    }}
  >
    {envioGratisDisponible
      ? "🎉 ¡Aprovecha tu envío gratis agregando más productos!"
      : `Agrega $${restante?.toLocaleString("es-CO") } más para conseguir envío gratis`}
  </span>
    </div>


    {/* 🧾 Resumen de pago */}
    <div
      style={{
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#ececec",
        borderRadius: "12px",
        padding: "10px 15px",
      }}
    >
      {/* ...resumen... */}
        {/* Fila: Productos */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "8px",
    }}
  >
    <span style={{ fontSize: "14px", color: "#000" }}>
      Productos ({calcularCantidadProductos()})
    </span>
    <span
      style={{
        color: "#000",
        fontWeight: "bold",
        fontSize: "14px",
      }}
    >
      ${subtotal?.toLocaleString("es-CO") }
    </span>
  </div>

  {/* Fila: Envío */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "8px",
    }}
  >
    <span style={{ fontSize: "14px", color: "#000" }}>Envío</span>
    <span
      style={{
        fontSize: "14px",
        fontWeight: "bold",
        color: envioGratisDisponible ? "green" : "#000",
      }}
    >
      {envioGratisDisponible ? "GRATIS" : `$${tarifaEnvio?.toLocaleString("es-CO") }`}
    </span>
  </div>

  {/* Fila: Total */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderTop: "1px solid #444",
      paddingTop: "10px",
      marginTop: "10px",
    }}
  >
    <span style={{ fontSize: "15px", color: "#000" }}>Costo Total:</span>
    <span
      style={{
        backgroundColor: "#08f9f5",
        padding: "6px 12px",
        borderRadius: "8px",
        color: "#000",
        fontWeight: "bold",
        fontSize: "15px",
      }}
    >
      ${calcularTotalConEnvio()?.toLocaleString("es-CO") }
    </span>
  </div>
    </div>

    {/* Botón de Enviar Pedido */}
    <button
  onClick={pagarConMercadoPago}
  disabled={!formularioValido()}   // ⛔ bloquea cuando falta algo
  style={{
    marginTop: "10px",
    padding: "8px",
    backgroundColor: formularioValido() ? "#87e310" : "#b5b5b5", // gris si está deshabilitado
    color: "#000",
    fontSize: "18px",
    fontWeight: "bold",
    borderRadius: "10px",
    border: "none",
    cursor: formularioValido() ? "pointer" : "not-allowed",
    transition: "0.3s",
    width:"100%",
    height:"50px"
  }}
  onMouseOver={(e) => {
    if (formularioValido()) e.target.style.backgroundColor = "#26e3e0";
  }}
  onMouseOut={(e) => {
    if (formularioValido()) e.target.style.backgroundColor = "#87e310";
  }}
>
  🚀 Pagar Ahora
</button>

  </div>
</div>








      {/* MODAL DE RESUMEN DE PEDIDO */}
      <Modal open={open} onClose={() => setOpen(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 300,
          maxHeight: "90vh",
          overflowY: "auto",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: "10px",
        }}
      >
        {/* ENCABEZADO */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold">
            <ReceiptIcon sx={{ verticalAlign: "middle", color: "blue" }} /> Resumen de la Orden
          </Typography>
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon color="error" />
          </IconButton>
        </Box>

        {/* MESA */}
        <Typography variant="subtitle1" fontWeight="bold" color="gray">
          Mesa: {mesa || "Sin número"}
        </Typography>


        <Typography fontWeight="bold">{"Ingresa un Titular del Pedido"}</Typography>
        {/* CAMPOS ADICIONALES */}
        <TextField
          fullWidth
          label="El pedido a nombre de:"
          variant="outlined"
          margin="normal"
          required
          value={nombreTitular}
          onChange={(e) => {
            const nombreTitular = e.target.value;
            setNombreTitular(nombreTitular);
            localStorage.setItem("titularpedido", nombreTitular); // 👈 Guardamos en localStorage
          }}
          
        />


        {/* LISTA DE PRODUCTOS */}
        {productos.length === 0 ? (
          <Typography color="gray" textAlign="center">
            (No hay productos en el carrito)
          </Typography>
        ) : (
          productos.map((producto, index) => (
            <Card key={index} sx={{ my: 1, backgroundColor: "#c9ffc9" }}>
              <CardContent>
                <Typography fontWeight="bold">{producto.Titulo}</Typography>
                <Typography variant="body2" color="text.secondary">
                  Cantidad: {producto.cantidad || 1} | Precio unitario: ${producto.Precio?.toLocaleString("es-CO")}
                </Typography>
                <Typography fontWeight="bold" color="green">
                  Total: ${((producto.Precio || 0) * (producto.cantidad || 1)).toLocaleString("es-CO")}
                </Typography>
              </CardContent>
            </Card>
          ))
        )}

        {/* TOTAL FINAL */}
        <Typography variant="h6" fontWeight="bold" color="black" mt={2}>
          💰 Total del Pedido: ${calcularTotal()}
        </Typography>

{/* NOTA PARA COCINA O BAR */}
{notaEditable && (
  <Box mt={2} p={2} bgcolor="#fff3cd" borderRadius="10px" border="1px solid #ffeeba">
    <Typography variant="subtitle2" fontWeight="bold" color="#856404" gutterBottom>
      📝 Nota para Cocina o Bar:
    </Typography>
    <Typography variant="body2" color="#856404">
      {notaEditable}
    </Typography>
  </Box>
)}



        <Typography variant="body2" color="gray" mb={1}>
          {/* ESPACIADO */}
        </Typography>
        <Typography variant="body2" color="gray" mb={1}>
          {/* ESPACIADO 2 */}
        </Typography>
       

        <Typography variant="body2" color="gray" mb={1}>
          Puedes ingresar tu correo para registrarte como cliente recurrente.
        </Typography>
        <TextField
          fullWidth
          label="Correo electrónico (opcional)"
          variant="outlined"
          margin="normal"
          value={correoCliente}
          onChange={(e) => {
            const correoCliente = e.target.value;
            setCorreoCliente(correoCliente);
            setCorreoValido(validarCorreo(e.target.value));
            localStorage.setItem("correocliente", correoCliente); // 👈 Guardamos en localStorage
          }}
          error={!correoValido}
          helperText={!correoValido ? "Correo electrónico inválido" : ""}
        />

        {/* BOTÓN DE CONFIRMAR */}
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2, borderRadius: "10px" }}
          onClick={handleConfirmar}
          disabled={!nombreTitular.trim() || !correoValido}
        >
          Confirmar Pedido
        </Button>
      </Box>


    </Modal>

    {openDialog && (
  <Modal open={openDialog} onClose={() => setOpenDialog(false)}>
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 300,
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 3,
        borderRadius: "10px",
      }}
    >
      <Typography variant="h6" fontWeight="bold">
        Seguridad Adicional
      </Typography>
      <Typography>Ingresa el código de la pantalla</Typography>
      <TextField
        fullWidth
        margin="dense"
        variant="outlined"
        value={codigoIngresado}
        onChange={(e) => setCodigoIngresado(e.target.value)}
      />
      <Box display="flex" justifyContent="space-between" mt={2}>
        <Button onClick={() => setOpenDialog(false)} color="secondary">
          Cancelar
        </Button>
        <Button onClick={verificarCodigo} color="primary">
          Validar
        </Button>
      </Box>
    </Box>
  </Modal>
)}



    </div>
  );
} 

export default ResumenPedidos;
